<template>
    <div id="box_component" class="box-component">
        <div class="box-component-inner">
            <h2>Forgot password</h2>
            <form @submit.prevent="validate">
                <div class="mw--360">
                    <p>Please enter your email below:</p>
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('email') && showErrors }">
                        <input  id="forgot_password_email"
                                name="email"
                                v-model="email"
                                v-validate
                                data-vv-rules="required|email"
                                data-vv-as="email"
                                :disabled="progress"
                                type="text">
                        <p class="field-error--description" v-show="errors.has('email') && showErrors">{{ errors.first('email') }}</p>
                    </div>
                    <vue-recaptcha
                        class="g-recaptcha"
                        @verify="onVerify"
                        @render="onRender"
                        :sitekey="recaptcha.sitekey">
                    </vue-recaptcha>
                </div>
                <div class="form-actions">
                    <button class="button--primary password"
                            :class="{ 'button--progress': progress }"
                            :type="progress ? 'button' : 'submit'">Submit</button>
                    <p @click="changeView(0)"
                       class="button--text">Back to login</p>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        dependencies: ['api', 'popup', 'recaptcha', 'status', 'user'],
        components: { VueRecaptcha },
        data () {
            return {
                progress: false,
                showErrors: false,
                email: ''
            }
        },
        methods: {
            onVerify: function (response) {
                this['g-recaptcha-response'] = response
            },
            onRender: function(recaptchaId) {
                this.recaptchaId = recaptchaId;
            },
            changeView (view) {
                this.$store.commit('loginFormView', 2)
                setTimeout(() => {
                    this.$store.commit('loginFormView', view)
                }, 600)
            },
            validate (e) {
                this.showErrors = false
                this.$validator.validateAll()

                if (!this.errors.any()) {
                    this.submit()
                }else{
                    this.showErrors = true
                }
            },

            submit () {
                this.progress = true
                let email = document.querySelector('#forgot_password_email').value

                this.$http.post(this.api.user.password.remind, {
                    email: email,
                    'g-recaptcha-response': this['g-recaptcha-response']
                }).then(() => {
                    this.progress = false
                    this.popup.show('Please check your email and follow the instructions provided.', 'OK', true);
                }, error => {
                    this.progress = false
                    this.$children.find(( component ) => {
                        return component.$widgetId === this.recaptchaId;
                    }).reset();
                    switch (error.status) {
                        default:
                            if (this.status['status' + error.status]) {
                                this.status['status' + error.status]()
                            } else {
                                this.popup.show(error.data.errors[0].message);
                            }
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_guest.scss';

    .button--text{
        font-size: 12px !important;
        margin: 15px auto -30px;
        cursor: pointer;

    &:hover,
    &:focus{
         text-decoration: underline;
     }
    }

    .g-recaptcha {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/partials/ForgotPassword.vue